import dialux from '../assets/clients/dialux.png';
import renulogix from '../assets/clients/renulogix.png';
import probuddy from '../assets/clients/probuddy.png';
import shareleads from '../assets/clients/shareleads.png';
import trioplus from '../assets/clients/trioplus.png';
import truzeau from '../assets/clients/truzeau.png';
import thecarelist from '../assets/clients/thecarelist.png';

export const featuredClients = [
  {
    id: 'dialux',
    label: 'Dialux',
    image: dialux,
    alt: 'Dialux',
  },
  {
    id: 'truzeau',
    label: 'Truzeau',
    image: truzeau,
    alt: 'Truzeau',
  },
  {
    id: 'shareleads',
    label: 'Shareleads',
    image: shareleads,
    alt: 'Shareleads',
  },
  {
    id: 'thecarelist',
    label: 'The Care List',
    image: thecarelist,
    alt: 'The Care List',
  },
];
